<template>
  <b-card>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="cog" />ข้อมูลงบประมาณ
    </h6>

    <div class="fund-source">
      <div class="fund-source-title">แหล่งเงินภายใน</div>
      <div class="fund">
        <div class="form-inline">
          <label class="mr-2">เงินสนับสนุนกิจกรรมนักศึกษา</label>
          <b-input v-model.number="funding.internal.osda" type="number" min="0" class="text-center mr-2" disabled />
          <span class="mr-4">บาท</span>
          <b-form-checkbox v-model="funding.internal.noOsda" :value="true" disabled>
            ไม่ใช้งบสนับสนุนกิจกรรมนักศึกษา
          </b-form-checkbox>
        </div>
      </div>
      <div class="fund">
        <div class="form-inline">
          <label class="mr-2">งบสำรองจ่าย</label>
          <b-input v-model.number="funding.internal.advance" type="number" min="0" class="text-center mr-2" disabled />
          <span>บาท</span>
          <span v-if="funding.internal.approvedAdvance" class="ml-2 text-primary">
            <strong>(สภานักศึกษาอนุมัติ {{ funding.internal.approvedAdvance | numeral('0,0.00') }} บาท)</strong>
          </span>
        </div>
      </div>
    </div>

    <div class="fund-source">
      <div class="fund-source-title">แหล่งเงินภายนอก</div>
      <div class="fund">
        <div class="mb-2">งบสนับสนุนจากบริษัท/บุคคล</div>
        <div class="other-funds">
          <div v-for="(_, index) in funding.external.sponsors" :key="index" class="form-inline mb-2">
            <label class="mr-2">-</label>
            <b-input v-model.trim="funding.external.sponsors[index].name" class="mr-2" disabled />
            <span class="mr-2">จำนวน</span>
            <b-input v-model.number="funding.external.sponsors[index].amount" type="number" min="0" class="text-center mr-2" disabled />
            <span class="mr-4">บาท</span>
          </div>
        </div>
      </div>
      <div class="fund">
        <div class="mb-2">งบอื่นๆ</div>
        <div class="other-funds">
          <div v-for="(_, index) in funding.external.other" :key="index" class="form-inline mb-2">
            <label class="mr-2">-</label>
            <b-input v-model.trim="funding.external.other[index].name" class="mr-2" disabled />
            <span class="mr-2">จำนวน</span>
            <b-input v-model.number="funding.external.other[index].amount" type="number" min="0" class="text-center mr-2" disabled />
            <span class="mr-4">บาท</span>
          </div>
        </div>
      </div>
    </div>

    <div class="fund-source">
      <div class="fund-source-title">รายการของที่รับบริจาคมา</div>
      <div class="fund">
        <div class="other-funds">
          <div v-for="(_, index) in funding.donations" :key="index" class="form-inline mb-2">
            <label class="mr-2">-</label>
            <b-input v-model.trim="funding.donations[index]" class="mr-2" disabled />
          </div>
        </div>
      </div>
    </div>

    <div class="expense-table-title">รายละเอียดการใช้จ่าย</div>
    <expenses-table v-model="valueForExpensesTable" :edit-mode="false" />
  </b-card>
</template>

<script>
import ExpensesTable from '@/components/project/ExpensesTable'

export default {
  components: {
    ExpensesTable
  },
  props: {
    funding: { type: Object, required: true },
    expenses: { type: Object, required: true }
  },
  computed: {
    valueForExpensesTable () { return { funding: this.funding, expenses: this.expenses } }
  },
  methods: {
    addOtherInternalFund () {
      this.funding.internal.other.push({ name: '', amount: 0 })
    },
    deleteOtherInternalFund (index) {
      this.$delete(this.funding.internal.other, index)
    },
    addOtherExternalFund () {
      this.funding.external.push({ name: '', amount: 0 })
    },
    deleteOtherExternalFund (index) {
      this.$delete(this.funding.external, index)
    }
  }
}
</script>

<style scoped lang="scss">
.fund-source{
  margin-bottom: 40px;
}

.fund-source-title, .expense-table-title {
  font-weight: $font-weight-bolder;
}

.fund {
  margin-left: 20px;
  margin-bottom: 10px;
}

.other-funds {
  margin-left: 20px;
}
</style>
